import ApiRequestVO from "../../../manager/api/ApiRequestVO";
import {IAnyObject} from "../../../common/SimpleInterface";
import ApiError from "../../../manager/api/ApiError";
import {getModelFactory} from "../../../model-factory/ModelFactory";
import {FactoryID} from "../../../model-factory/type-interface/ModelFactoryType";
import {SearchBasicDataModel} from "../../search/SearchBasicDataFactory";
import {IPopulateIDs} from "../../../model-factory/type-interface/ModelFactoryInterface";
import {MessageDataModel, MessageSearchParams} from "./MessageDataFactory";
import DataFactory from "../../../model-factory/basic/data/DataFactory";
import SearchPageListDataFactory, {SearchPageBasicDataModel} from "../../search/SearchPageBasicDataFactory";

export class MessagePageListDataModel extends SearchPageBasicDataModel
{

    searchParams:MessageSearchParams = new MessageSearchParams();


    onModelConditionsApplied()
    {
        super.onModelConditionsApplied();
        this.requirePages();
    }

    resetChoiceList(): void
    {
        super.resetChoiceList();
        this.requirePages();
    }

    getPopulateRequestVO(): ApiRequestVO|null
    {
        const endpoint = "/message/count";

        const requestVO = new ApiRequestVO(true);
        requestVO.endpoint = endpoint;
        requestVO.params = {}
        if(this.searchParams.searchTermID && this.searchParams.searchTermID !== "search_all"){
            requestVO.params.search_term = encodeURIComponent(this.searchParams.searchTerm);
        }
        if(!this.searchParams.sortDesc){
            requestVO.params.sort_asc = true;
        }

        return requestVO;
    }

    getEntryIndexRequestVO(entryID:string): ApiRequestVO|null
    {
        const endpoint = "/message/"+entryID+"/index";

        const requestVO = new ApiRequestVO(true);
        requestVO.endpoint = endpoint;

        return requestVO;
    }

    populateWithRequestResponse(response: IAnyObject, replaceData:boolean): ApiError | null
    {
        let error =  super.populateWithRequestResponse(response, replaceData);
        if(error){
            return error;
        }
        this.numberOfEntries = response.count && !isNaN(response.count) ? parseInt(response.count) : 0;
        this.actualPageCount = this.numberOfEntries > 0 ? Math.ceil(this.numberOfEntries / this.entryLimit) : 0;
        this.requirePages();
        return null;
    }

    requirePages()
    {
        const pageCount = Math.max(this.actualPageCount, 1);

        let pageObjects:IAnyObject[] = [];
        for(let i = 0; i < pageCount; i ++)
        {
            const pageNumber = i + 1;
            pageObjects.push({
                id: pageNumber,
                name: pageNumber
            });

        }
        this.populateChoiceList(pageObjects, true);
    }

    getChildModel(pageNumber?:number): MessageDataModel|null
    {
        pageNumber = pageNumber ? pageNumber : 1;
        if(pageNumber < 1 || pageNumber > this.choiceOrder.length){
            return null
        }
        return getModelFactory().messageData.getMessageDataModel(
            this.searchParams,
            pageNumber
        )
    }
}

export default class MessagePageListDataFactory extends SearchPageListDataFactory
{

    id: FactoryID = "message_page_list_data";

    birth(id: string): MessagePageListDataModel
    {
        return new MessagePageListDataModel(id);
    }

    getMessagePageListDataModel(searchParams:MessageSearchParams): MessagePageListDataModel
    {
        const populateIDs:IPopulateIDs = {
            search_sort_by: searchParams.sortBy,
        };
        if(searchParams.searchTermID){
            populateIDs.search_term_id = searchParams.searchTermID;
        }
        return this.requireModel(populateIDs) as MessagePageListDataModel;
    }
}